import modalA11y from 'views/assets/scripts/modal'
import createA11Dialog from 'views/utils/createA11Dialog'

export default () => {
  if (document.querySelector('.o-OutOfStockOverlayContent')) {
    const deliveryModal = <HTMLElement>(
      document.querySelector('.o-OutOfStockOverlayContent #productDeliveryInfo')
    )

    const outOfStockModalElement = <HTMLElement>(
      document.getElementById('out-of-stock-modal')
    )

    const modals = modalA11y()

    /* We need to show delivery information in the overlay of the replacement product
    on PDP. Since the delivery overlay is still on PDP hidden, although there is no link to open it,
    we need to destroy all existing popups and recreate them to avoid showing it twice, on PDP
    and in the overlay, when they are triggered from the replacement overlay.
    */
    modals.forEach(modal => {
      if (
        modal._id === 'productDeliveryInfo' ||
        modal._id === 'out-of-stock-modal'
      ) {
        modal.destroy()
      }
    })

    const deliveryModalOpeners = document.querySelectorAll(
      '.o-OutOfStockOverlayContent button[data-a11y-dialog-show="productDeliveryInfo"]'
    )
    const newDeliveryModal = createA11Dialog({ element: deliveryModal })
    const outOfStockModal = createA11Dialog({ element: outOfStockModalElement })
    outOfStockModal.show()

    deliveryModalOpeners?.forEach(deliveryModalOpener => {
      deliveryModalOpener.addEventListener('click', () => {
        newDeliveryModal.show()
      })
    })

    deliveryModal
      ?.querySelector('a[name="modal-close-button"]')
      ?.addEventListener('click', () => {
        newDeliveryModal.hide()
      })

    outOfStockModalElement
      ?.querySelector('a[name="modal-close-button"]')
      ?.addEventListener('click', () => {
        outOfStockModal.hide()
      })
  }
}
